import { Stack, Typography, useTheme } from "@mui/material";
import { ChevronRight, type LucideIcon } from "lucide-react";
import type { FC } from "react";
import { IconBox } from "web_myplann/Shared/Components/IconBox";

type Props = {
	icon: LucideIcon;
	iconBg: string;
	iconColor: string;
	label: string;
	onClick: () => void;
	showDivider?: boolean;
};

export const ProfileToolRow: FC<Props> = ({
	icon: Icon,
	iconBg,
	iconColor,
	label,
	onClick,
	showDivider,
}) => {
	const theme = useTheme();

	return (
		<Stack
			direction="row"
			alignItems="center"
			gap={1.6}
			px={1.6}
			py={1.2}
			onClick={onClick}
			borderBottom={
				showDivider
					? theme.colors.border.solid(theme.palette.grey[100])
					: "none"
			}
			sx={{ cursor: "pointer" }}
		>
			<IconBox bg={iconBg} size={36} shape="circle">
				<Icon size={theme.iconSize.sm} color={iconColor} />
			</IconBox>
			<Typography variant="body1" flex={1}>
				{label}
			</Typography>
			<ChevronRight size={theme.iconSize.sm} color={theme.palette.grey[400]} />
		</Stack>
	);
};
